import { Button } from "@/design-system/components/ui";
import { Modal } from "@/components/ui/Modal";
import { PackageAssigneesEditor } from "@/components/Collection/PackageAssigneesEditor";

interface ManageAssigneesModalProps {
  open: boolean;
  onClose: () => void;
  packageId: string;
  /** Forwarded to the editor — fires after every add / remove so the
   *  opening surface (e.g. the queue list row) can refresh in place. */
  onChanged?: () => void;
}

/**
 * External Portal v2 (PROB-G) — second trigger point for the Manage
 * Assignees control. The staging-detail panel surfaces the same
 * <PackageAssigneesEditor> inline; this modal lets staff manage a package's
 * assignees straight from the queue list row without navigating into the
 * detail page. The editor writes immediately, so the only footer action is
 * "Done".
 */
export function ManageAssigneesModal({
  open,
  onClose,
  packageId,
  onChanged,
}: ManageAssigneesModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Manage assignees"
      description="Add or remove the internal staff members assigned to this package. Changes save immediately."
      size="md"
      footer={
        <Button type="button" variant="secondary" onClick={onClose}>
          Done
        </Button>
      }
    >
      <PackageAssigneesEditor packageId={packageId} onChanged={onChanged} />
    </Modal>
  );
}
